import { defineStore } from 'pinia';

export const useAdminSidebarStore = defineStore('adminSidebar', {
    state: () => ({
        isCollapsed: false
    }),
    persist: {
        pick: [
            'isCollapsed',
        ]
    },
})
